import { c as _c } from "react/compiler-runtime";
import { LinkIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/components/ui/link';
import { SOCIAL_LINKS } from '@/constants/navigation';
export function Connect() {
  const $ = _c(8);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LinkIcon className="size-4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("homepage.about-me.connect");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex items-center gap-2">{t0}<h2 className="text-sm">{t1}</h2></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-4 px-2">{SOCIAL_LINKS.map(_temp)}</div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="flex flex-col gap-6 rounded-2xl p-4 shadow-feature-card lg:p-6">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(link) {
  const {
    href,
    title,
    icon
  } = link;
  return <Link key={href} href={href} className="flex w-fit items-center gap-3 text-muted-foreground transition-colors hover:text-foreground [&>svg]:size-4.5">{icon}<h3>{title}</h3></Link>;
}